import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bigNumberRounder',
})
// Rounds big number to @pow number of zeros at the end
export class BigNumberRounder implements PipeTransform {
  transform(value: number, pow: number): number {
    if (value) {
      return Math.pow(10, pow) * Math.round(value / Math.pow(10, pow));
    }
  }
}
